/**
 * Üyenin ekranda görünen adı. Kurallar: memberName.test.ts (MN-01…MN-05).
 *
 * Hesaplı üyede profil adı, hesapsız sırada (taşınmış gün, misafir) defterdeki ad.
 */
export interface NamedMember {
  users?: { full_name?: string | null } | null
  display_name?: string | null
}

export function memberDisplayName(member: NamedMember, fallback = 'Üye'): string {
  return member.users?.full_name?.trim() || member.display_name?.trim() || fallback
}

/**
 * Bir turun alacaklısı — panel kartı ve ajanda için. Kurallar: memberName.test.ts (MN-10…MN-12).
 *
 * B-42 (canlı test, 19 Eylül 2026): panel yalnız hesap profilinden okuduğu için hesapsız
 * sıralardan oluşan günde "Sıra Bekleniyor" yazıyordu. Ad defterden de okunur; kimlik
 * (varsa) "bu sıra bende mi" kontrolü için korunur.
 */
export interface ReceiverSeat extends NamedMember {
  user_id?: string | null
  turn_index?: number | null
}

export function nextReceiver(
  members: ReceiverSeat[] | null | undefined,
  currentCycle: number
): { id: string | null; full_name: string } | null {
  const seat = (members ?? []).find(m => m.turn_index === currentCycle)
  if (!seat) return null
  return { id: seat.user_id ?? null, full_name: memberDisplayName(seat, 'Sıradaki kişi') }
}
